import gsap from "gsap";

export default {
  init() {
    const form = document.querySelector(".views-exposed-form");
    if (!form) return;

    const top = form.querySelector(".view-form__top");
    const filters = top.querySelectorAll(".select");
    const urlParams = new URLSearchParams(window.location.search);

    // filters

    for (const filter of filters) {
      const select = filter.querySelector("select");
      const clear = filter.querySelector(".select-clear");
      const tag = filter.querySelector(".select-tag");
      const feedback = filter.querySelector(".select-feedback");
      const defaultValue = select.querySelector("option").value;

      if (select.value !== defaultValue) {
        clear.classList.add("is-active");
        tag.classList.add("is-active");
      }

      filter.addEventListener("change", () => {
        form.submit();
        feedback.classList.add("is-active");
      });

      clear.addEventListener("click", () => {
        feedback.classList.add("is-active");
        tag.classList.remove("is-active");
        clear.classList.remove("is-active");
        select.value = defaultValue;
        form.submit();
      });
    }

    // letters
    const letterSelect = top.querySelector("#edit-lettre--2");
    const letters = top.querySelectorAll(".authors__nav-letter.is-clickable");

    for (const letter of letters) {
      letter.addEventListener("click", () => {
        const letterValue = letter.innerText.trim();
        letterSelect.value = letterValue;
        letter.classList.add("is-loading");
        form.submit();
      });
    }

    // search

    const search = top.querySelector(".form-item-recherche");
    const searchInput = search.querySelector("input[type='text']");
    const searchSubmit = search.querySelector(".view-form__search-submit");
    const searchClear = search.querySelector(".view-form__search-clear");
    const searchFeedback = search.querySelector(".view-form__search-feedback");

    if (searchInput.value) {
      searchClear.classList.add("is-active");
      searchSubmit.classList.remove("is-active");
    }

    searchSubmit.addEventListener("click", () => {
      form.submit();
      searchFeedback.classList.add("is-active");
    });

    searchInput.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        searchFeedback.classList.add("is-active");
      }
    });

    searchClear.addEventListener("click", () => {
      searchInput.value = "";
      searchFeedback.classList.add("is-active");
      form.submit();
    });

    // sort
    const bottom = form.querySelector(".view-form__bottom");
    const sortSelect = bottom.querySelector("select");
    const sortFeedback = bottom.querySelector(".select-feedback");

    sortSelect.addEventListener("change", () => {
      sortFeedback.classList.add("is-active");
      form.submit();
    });

    // radios

    const radios = form.querySelectorAll(".view-form__radio");

    for (const radio of radios) {
      const inputs = radio.querySelectorAll(".view-form__radio-input");
      const feedback = radio.querySelector(".view-form__radio-feedback");

      for (const input of inputs) {
        const paramValue = urlParams.get(input.name);

        if (paramValue === input.value) {
          input.checked = true;
        } else if (!paramValue && input === inputs[0]) {
          input.checked = true;
        }

        input.addEventListener("change", () => {
          if (paramValue !== input.value) {
            feedback.classList.add("is-active");
            form.submit();
          }
        });
      }
    }
  },
};
